import React from 'react';
import { connect } from 'react-redux';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';
import { fetchStaffBirthdayList, exportStaffBirthdayList, linkToNewRouter, fetchAddressList } from '../../actions/employee-management-actions.js';
import { Table,
	Button,
	Modal,
	Spin,
	Icon,
	DatePicker,
  TreeSelect,
  Form } from 'antd';
import './style.less';

const { MonthPicker } = DatePicker;

const FormItem = Form.Item;

const { TreeNode } = TreeSelect;

const mapStateToProps = state => {
    return {
        routing: state.routing,
        employeeManagement: state.employeeManagement,
        departmentStructure: state.departmentStructure
    }
}

const mapDispatchToProps = { fetchStaffBirthdayList, exportStaffBirthdayList, fetchDepartmentsList, linkToNewRouter, fetchAddressList }

@connect(mapStateToProps, mapDispatchToProps)

class StaffBirthday extends React.Component {
	constructor(props){
     	super(props);
        this.columns = [{
          title: '部门',
          dataIndex: 'department_name',
          key: 'department_name',
          sorter: true,
          className: "table-global-head-tiny"
        }, {
          title: '职位',
          dataIndex: 'position_name',
          key: 'position_name',
          sorter: true,
          className: "table-global-head-tiny"
        }, {
          title: '工号',
          dataIndex: 'job_number',
          key: 'job_number',
          sorter: true,
          className: "table-global-head-tiny"
        }, {
          title: '中文名',
          dataIndex: 'real_name',
          key: 'real_name',
          sorter: true,
          className: "table-global-head-tiny"
        }, {
          title: '英文名',
          dataIndex: 'english_name',
          key: 'english_name',
          sorter: true,
          className: "table-global-head-tiny"
        }, {
          title: '出生日期',
          dataIndex: 'birthday',
          key: 'birthday',
          sorter: true,
          className: "table-global-head-tiny"
        }, {
          title: '年龄',
          dataIndex: 'birthday_int',
          key: 'birthday_int',
          className: "table-global-head-short"
        },  {
          title: '性别',
          dataIndex: 'gender',
          key: 'gender',
          sorter: true,
          className: "table-global-head-tiny"
        }, {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          // className: "table-global-head",
          render: (text, record) =>
               <span>
                   <Button icon="info-circle-o" onClick={this.handleEditEmployee.bind(this, record)} size="small" className="row-action-btn">详情</Button>
               </span>
             
        }];
     }

  state = {department_ids:"", month:"", order_property:"", is_order_asc:true};
  componentDidMount() {
    this._fetchStaffBirthdayList()
    this._fetchDepartmentsList()
  }
 	_fetchStaffBirthdayList = (params) => {
     	this.props.fetchStaffBirthdayList(params)
 	}
 	_fetchDepartmentsList = (params) => {
		this.props.fetchDepartmentsList(params);
 	}

  handleStaffBirthdayListSearch = (value) => {
    let params = {
      department_ids: this.state.department_ids,
      month: this.state.month,
      order_property: this.state.order_property,
      is_order_asc: this.state.is_order_asc
    }
    this.props.fetchStaffBirthdayList(params)
  }

    handleEditEmployee = (record) => {
          // this.props.fetchEmployeeDetail({'modelId': record.id})
          sessionStorage.setItem("rosterReadOnly", "yes")
         this.props.linkToNewRouter(`/employee/detail/${record.id}`)
    }

    handleDepartmentSelectChange = (value) => {
         let params = {
             department_ids: value
         }
         this.setState({department_ids: value});
         this.props.fetchStaffBirthdayList(params)
    }

    handleExportStaffBirthdayList = () => {
    	let ref = Modal.info({content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"});
    	let params = {
    		department_ids: this.state.department_ids,
    		month: this.state.month,
    	}
    	this.props.exportStaffBirthdayList(params, url => {
    		ref.destroy();
			  window.open(url);
    	});
    }

 	fetchStaffBirthdayListPage(pagination, filters, sorter) {
 		let params = {
      page: pagination.current
    }
    let gets = {};
    this.setState({order_property:sorter.field, is_order_asc:sorter.order==='ascend' ? true : false}, () => {
      for (let key in this.state) {
        if (this.state[key] !== undefined) {
          gets[key] = this.state[key];
        }
      }
    });
    gets = { ...gets, ...params }
		this.props.fetchStaffBirthdayList(gets)
	}

  handleMonthPickerChange = (val) => {
    let get = {};
    let month = val ? val.format('MM') : "";
    this.setState({month: month}, () => {
      for (let key in this.state) {
        get[key] = this.state[key];
      }
    });
    this.props.fetchStaffBirthdayList(get)
  }

  renderTreeNodes = (data) => {
      return data.map((item) => {
        if (item.children) {
          return (
            <TreeNode title={item.name} value={`${item.id}`} key={item.id} dataRef={item}>
              { item.children.length !== 0 && this.renderTreeNodes(item.children) }
            </TreeNode>
          );
        }
        return <TreeNode {...item} />;
      });
  }

  onSelectTreeChange(ids) {
    let get = {}
    this.setState({department_ids: ids}, () => {
      for (let key in this.state) {
        get[key] = this.state[key];
      }
    });
    this.props.fetchStaffBirthdayList(get)
  }
	render() {
		const columns = this.columns;
		const { birthdayList } = this.props.employeeManagement;
    	const { departmentsList } = this.props.departmentStructure;
      const { getFieldDecorator } = this.props.form;
		return (
			<div className="app-module-item">
				<div className="colAction">
					{this.props.access.birthdayList.export_value && <Button type="primary" style={{marginTop:"20px"}} onClick={this.handleExportStaffBirthdayList}>
						<Icon type="cloud-download-o" />
						<span>导出</span>
					</Button>}

			<div style={{float:'right',margin:'20px 5px 0px'}}>
			<Button type="primary" onClick={this.handleStaffBirthdayListSearch}>
				<span>查询</span>
			</Button>
			</div>
      <div className="birthday-pick-month" style={{float:'right',margin:'20px 5px 0px'}}>
        <span>选择月份 : </span>
        <MonthPicker onChange={this.handleMonthPickerChange} placeholder="请选择月份" format={'MM'}/>

      </div>

          {
                         departmentsList ?
				<div style={{float:'right',margin:'15px 5px 0px'}}>
          <span style={{float:'left',height:"40px",lineHeight:"40px",marginRight:"5px"}}>部门 : </span>

                         <Form layout="inline" style={{float:'left'}}>
                          <FormItem>
                            {getFieldDecorator('department_id')(
                              <TreeSelect style={{minWidth:"300px",marginBottom:'15px'}}
                                 multiple
                                 placeholder="请选择部门"
                                 showSearch={false}
                                 autoExpandParent={true}
                                 dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                 treeDefaultExpandAll
                                 onChange={this.onSelectTreeChange.bind(this)}>
                                  {this.renderTreeNodes(departmentsList)}
                              </TreeSelect>
                            )}
                          </FormItem>
                          </Form>


				</div>	
                                 :
            <Spin />
                     }
			</div>
      <div style={{clear:"both"}}></div>
				{
                   birthdayList ?
                     <Table scroll={{x: 800}}
                         columns={columns}
                         dataSource={birthdayList.Data}
                         rowKey={record => record.id}
                         pagination={{
                          total: birthdayList.Total, 
                          pageSize:birthdayList.PageSize,
                          current: birthdayList.Page, 
                          defaultCurrent: 1}}
                         onChange={this.fetchStaffBirthdayListPage.bind(this)}
                     />
                     :
                     <Spin />
                 }			
			</div>
		)
	}

}

StaffBirthday = Form.create()(StaffBirthday)

export default LayoutWrapper(StaffBirthday);


// WEBPACK FOOTER //
// ./src/routes/EmployeeManagement/StaffBirthday.js